import {
  canEnableNotifications,
  notificationSetupCopy,
  type NotificationSetupState,
} from '../../lib/notificationSetup';

type Props = {
  setupState: NotificationSetupState;
  onEnable: () => void;
  webPushConfigured: boolean;
};

/**
 * Only when the user still needs to enable / fix browser notifications.
 * Never show a green “Alerts enabled” success card in the bell panel.
 */
export function NotificationSetupCard({ setupState, onEnable, webPushConfigured }: Props) {
  // Granted (and any non-actionable success state): hide completely.
  if (setupState === 'granted') return null;

  const canEnable = canEnableNotifications(setupState);
  // Keep denied / insecure / ios / unsupported tips; hide idle "ready" only shows enable CTA via canEnable.
  if (
    setupState !== 'ready' &&
    setupState !== 'denied' &&
    setupState !== 'insecure' &&
    setupState !== 'ios-browser' &&
    setupState !== 'unsupported'
  ) {
    return null;
  }

  const { title, message } = notificationSetupCopy(setupState);

  return (
    <div
      className={`notifications-setup${setupState === 'insecure' ? ' notifications-setup--warn' : ''}`}
    >
      <strong>{title}</strong>
      <p>{message}</p>
      {canEnable && (
        <button type="button" className="btn-primary btn-sm" onClick={onEnable}>
          Enable notifications
        </button>
      )}
      {webPushConfigured && canEnable && (
        <span className="notifications-setup__note">
          Allow once on this device. You only receive alerts for portals you can access.
        </span>
      )}
      {!webPushConfigured && canEnable && (
        <span className="notifications-setup__note">
          Server Web Push is not configured yet — alerts will only work while this tab is open.
        </span>
      )}
    </div>
  );
}
